"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var PreviewMessage = function (_a) {
    var modelImageIcon = _a.modelImageIcon, messageKey = _a.messageKey, iconClassName = _a.iconClassName, onConvertClick = _a.onConvertClick, _b = _a.titleKey, titleKey = _b === void 0 ? 'filesPreview/preview/dwg/dearSokoProUser' : _b;
    return (React.createElement("div", { className: "upload-model" },
        React.createElement("div", { className: "model-image" }, modelImageIcon),
        React.createElement("div", { className: "upload-model-content" },
            React.createElement("span", { className: "upload-model-title" },
                React.createElement("strong", null, (0, translation_1.getLocalization)(titleKey))),
            React.createElement("div", null,
                React.createElement("span", null, (0, translation_1.getLocalization)(messageKey)),
                React.createElement("span", __assign({ className: "model-upload-button" }, (onConvertClick && { onClick: onConvertClick })),
                    React.createElement(Icon_1.Icon, { className: iconClassName }))))));
};
exports.default = PreviewMessage;
